<script>
  import BaseForm from '../../form';
  import FileInput from '../../file-input';

  export default {
    extends: BaseForm,

    components: {
      FileInput,
    },

    data() {
      return {
        form: {
          file: null,
          type: null,
        },
        rules: {
          file: [{validator: this.fieldExternalValidator}],
        },
      };
    },

    computed: {
      /**
       * @return {boolean}
       */
      isFileSelected() {
        return Boolean(this.form.file);
      },

      /**
       * @return {string}
       */
      fileInfo() {
        const size = _.ceil(_.get(this.form.file, 'size') / 1024);
        const name = _.get(this.form.file, 'name');

        return `${name}, ${size}Kb`;
      }
    },

    methods: {
      /**
       * @param {Object} params
       * @return {undefined}
       */
      store(params = {}) {
        this.isBusy = true;
        const {params: configParams, ...others} = this.getConfig();
        const config = {...others, params: _.assign({}, configParams || {}, params)};
        axios.post(this.storeUrl, this.getForm(), config)
            .then(this.storeSuccess)
            .catch(this.handleErrorResponse);
      },

      /**
       * @param {Object} res
       * @return {boolean}
       */
      storeSuccess({data}) {
        this.isBusy = false;
        this.$emit('stored', data);
      },

      /**
       * @param {Object} response
       * @return {boolean}
       */
      handleErrorResponse({response: {data, status}}) {
        const {errors, message} = data || {};
        if (status === 422 && errors) {
          this.errors = errors;
          this.$refs.form.validate(() => null);
          this.$message.error(message);
        } else if (status === 428) {
          this.confirmStoring(message);
        } else if (message && _.isString(message)) {
          this.$message.error(message);
        }
        this.isBusy = false;
      },

      /**
       * @param {String} message
       */
      confirmStoring(message) {
        this.$confirm(message, 'Action confirmation', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        })
        .then(() => {
          this.store({suppress_confirmation: '1'});
        })
        .catch(_.noop);
      },

      /**
       * @return {FormData}
       */
      getForm() {
        const formData = new FormData();
        const form = _.assign({}, this.form, {_method: this.method});
        _.each(form, (value, name) => {
          if (_.isNull(value)) {
            return;
          }
          formData.append(name, value)
        });

        return formData;
      },

      /**
       * @param {Object} model
       */
      initForm({file = null, type = null}) {
        this.form = {file, type};
      },

      /**
       * @return {undefined}
       */
      clearFile() {
        this.form.file = null;
      },
    },
  }
</script>
